import { CreateAttachmentHandler } from 'owa-attachment-filepicker';
import {
    AttachmentSelectedFolderIdentifierType,
    DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH,
} from 'owa-attachment-folder-picker';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import getComposeUniqueState from 'owa-mail-compose-actions/lib/utils/getComposeUniqueState';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import { ComposeViewState } from 'owa-mail-compose-store';
import { lazyInsertLinks } from 'owa-insert-link';
import { aFPCreateAttachmentHandler } from './createAttachmentHandler';

// When the selected file is over size limit, we will display second panel to upload and create reference attachment or a link from it.
export function getCreateClassicAttachmentHandler(
    composeViewState: ComposeViewState,
    sxsId: string,
    targetWindow: Window,
    shouldBigFileTurnIntoLink: boolean
): CreateAttachmentHandler {
    return attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(
        composeViewState.attachmentWell,
        (files, properties, dataProvider) =>
            aFPCreateAttachmentHandler(files, composeViewState, properties, dataProvider),
        getComposeUniqueState(composeViewState),
        targetWindow,
        async params => {
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(
                params.files,
                composeViewState,
                composeViewState,
                getCurrentFromAddress(composeViewState.toRecipientWell),
                targetWindow,
                sxsId,
                null /* selectionText */,
                {
                    shouldShare: true,
                    shareProperties: {
                        folderInfo: {
                            identifierType: AttachmentSelectedFolderIdentifierType.SpecialFolder,
                            identifier: DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH,
                        },
                    },
                }
            );
        },
        shouldBigFileTurnIntoLink
    );
}
